<template>
  <div class="truncate">
    <a
      :title="presentation.name"
      class="truncate text-link"
    >
      <span
        class="text-base-60"
        v-if="!isSharedPresentation"
      >
        {{ folderName }}
      </span>
      <span>{{ presentation.name }}</span>

    </a>
    <span class="presentation-info">
      <PresentationMode :presentation="presentation" class="min-w-max" />

      <span class="ml-4 min-w-max">
        <aha-icon-container>
          <aha-icon
            name="slides"
            width="10"
            height="10"
            viewBox="0 0 12 12"
            v-tooltip="'Number of slides'"
          />
        </aha-icon-container>
        <span class="text-xs text-base-80">
          {{ presentation.slideCount }}
        </span>
      </span>

      <span
        class="ml-4 min-w-max"
        @click.stop="() => {}"
        v-tooltip="getParticipantCountTooltip(presentation)"
      >
        <aha-icon-container>
          <aha-icon
            name="people"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          />
        </aha-icon-container>
        <span class="text-xs text-base-80">
          <aha-formatter
            :value="presentation.participantsCount || presentation.onlineCount"
            type="number"
          />
        </span>
      </span>

      <Reactions
        class="hidden ml-4 xl:inline-block"
        @click.stop="showPresentationReport"
        :presentation="presentation"
      />

      <ReportButton class="hidden ml-4" :presentation="presentation" />
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Utils from '@/util'
import constants from '@/constant'
import socketHelper from '@/helpers/socket/socket-helper'

import Reactions from '@/components-v2/my-presentations/main-table/Reactions.vue'
import PresentationMode from '@/components-v2/my-presentations/main-table/PresentationMode.vue'
import ReportButton from './ReportButton.vue'

export default {
  components: {
    Reactions,
    PresentationMode,
    ReportButton,
  },
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    isSharedPresentation: {
      type: Boolean,
      required: true,
    },
    folderName: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapActions('presentationReport', ['selectPresentationAction', 'generateReportAction', 'subscribeReportAction', 'openReportPanelAction']),
    getParticipantCountTooltip(presentation) {
      let tooltip
      if (presentation.participantsCount === null) {
        tooltip = 'Largest live audience'
      } else {
        tooltip = `Total participants: <b>${presentation.participantsCount || 0}</b>. Largest live audience: <b>${presentation.onlineCount}</b>.`
      }

      return {
        content: tooltip,
      }
    },
    showPresentationReport() {
      this.selectPresentationAction({
        presentation: this.presentation,
      })
      if (this.presentation && this.presentation.uniqueAccessCode) {
        socketHelper.joinRoomPresentation(this.presentation.uniqueAccessCode)
        this.subscribeReportAction(this.presentation)
      }
      this.openReportPanelAction()
      Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_LIST, 'Presentation > Click view report')
    },
  },
}
</script>

<style lang="scss" scoped>
.presentation-info {
  @apply flex flex-wrap items-center mt-1 font-normal leading-6;
}
</style>
